<main class="main">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>Intro + CTA:</div>
        <div class="remove-block-button">
          <a class="btn btn-sm" (click)="removeBlock()"><i class="bi bi-trash-fill remove-block-icon"></i></a>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <app-block-text
            [maxLength]="4000"
            [type]="'content'"
            (handleOnChange)="onChange($event, 'IntroText')"
            [blockData]="block.variables?.IntroText ?? ''"
            [placeholder]="introTextPlaceholder"
            variable="IntroText"
          ></app-block-text>
        </div>
        <div class="col-12 gy-3">
          <app-block-text
            [maxLength]="500"
            [type]="'action-link'"
            (handleOnChange)="onChange($event, 'MainCtaLink')"
            [blockData]="block.variables?.MainCtaLink ?? ''"
            [placeholder]="mainCtaLinkPlaceholder"
            variable="MainCtaLink"
            (handleOnSegmentChange)="handleOnSegmentChange($event, 'MainCtaLinkSegmentRegex')"
            [selectedSegment]="block.variables?.MainCtaLinkSegmentRegex ?? ''"
          ></app-block-text>
        </div>
        <div class="col-12 gy-3">
          <app-block-text
            [type]="'content'"
            (handleOnChange)="onChange($event, 'MainCtaText')"
            [blockData]="block.variables?.MainCtaText ?? ''"
            [placeholder]="mainCtaTextPlaceholder"
            [maxLength]="30"
            variable="MainCtaText"
          ></app-block-text>
        </div>
      </div>
    </div>
    <div
      class="right-side-container"
      [id]="block.blockId"
      (click)="onContainerClick($event)"
    >
      <app-pin [block]="block"></app-pin>
      <div class="right-side">
        <div class="row text-center">
          <div class="col-12" [innerHTML]="$safeNavigationMigration(block.variables?.IntroText)"></div>
          <div class="col-12 mt-2" *ngIf="block.variables?.MainCtaText">
            <a
              class="btn btn-primary"
              [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.MainCtaLink))"
              target="_blank"
              [innerHTML]="$safeNavigationMigration(block.variables?.MainCtaText)"
            ></a>
          </div>
        </div>
      </div>
    </div>
    <div class="comments-side" *ngIf="!isPreview">
      <app-notification
        [notifications]="block.notifications"
        [blockId]="block.blockId"
      ></app-notification>
    </div>
  </div>
</main>
